var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-71"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,240.16a60.34,60.34,0,0,0,1.69,23.39c2.14,7.46,6.1,14.41,11.74,19.09a30.85,30.85,0,0,0,4.41,3.11,27.71,27.71,0,0,0,4.81,2.12,27.21,27.21,0,0,0,10.09,1.35c6.79-.37,13.32-2.93,19.26-6.63.35-.23.77-.47,1.08-.69l.85-.64c.56-.46,1.12-.9,1.66-1.41a28,28,0,0,0,3.12-3.28,52.55,52.55,0,0,0,5.51-8.13,149.14,149.14,0,0,0,9-19.68c5.4-14,10.15-29,15.49-44.11q2-5.67,4.16-11.39c1.41-3.82,2.94-7.64,4.53-11.48a169.14,169.14,0,0,1,11.41-23.16c1.2-2,2.49-3.92,4-5.89.74-1,1.55-2,2.41-2.94s1.76-1.85,2.68-2.71a51.72,51.72,0,0,1,11.86-8.16c8.19-4.18,16.34-6.44,24.2-8.77s15.57-4.4,23-7.17a103.09,103.09,0,0,0,20.83-10.31,67.42,67.42,0,0,0,16.61-15.26c4.55-6,8.14-12.58,9.75-19.27a33.79,33.79,0,0,0,1-9.75,22.93,22.93,0,0,0-2.15-8.49A19,19,0,0,0,239.45,50a25.73,25.73,0,0,0-7.87-1.24,35.29,35.29,0,0,0-8.47,1c-.72.17-1.44.38-2.16.59l-2.56.77c-1.69.54-3.38,1.1-5,1.72-3.32,1.23-6.58,2.6-9.82,4.16-6.47,3.1-12.93,7-20.1,11.18A180.86,180.86,0,0,1,159.93,80a140.81,140.81,0,0,1-26.08,7.49c-1.1.23-2.2.38-3.3.57l-3,.48c-1.63.27-3.29.59-4.94,1a100.13,100.13,0,0,0-9.81,2.69c-12.9,4.24-24.51,11-33.35,20.45a79.85,79.85,0,0,0-11.71,16,84.21,84.21,0,0,0-4.55,9.4,103.57,103.57,0,0,0-3.66,10.22c-1,3.53-2,7.16-2.71,10.89-.37,1.74-.75,4-1.14,6.1s-.87,4.2-1.37,6.27a181.18,181.18,0,0,1-7.62,24.13c-3,7.77-6.5,15.23-10,22.55-1.76,3.66-3.51,7.3-5.13,11A43.13,43.13,0,0,0,28,240.16Zm-3.1-.33a33.52,33.52,0,0,1,1.38-6.22c.6-2,1.31-3.91,2-5.82,1.4-3.82,2.86-7.58,4.15-11.38s2.48-7.61,3.48-11.46,1.77-7.74,2.41-11.62A118.34,118.34,0,0,0,39.59,170c-.07-1.93-.22-3.86-.36-5.78s-.39-3.69-.57-6a119.63,119.63,0,0,1-.39-13.16,95.59,95.59,0,0,1,4.46-26.92A83.59,83.59,0,0,1,55.9,92.91,93.07,93.07,0,0,1,76.82,73.17a105.66,105.66,0,0,1,25.24-12.71,112.18,112.18,0,0,1,13.47-3.79c2.28-.5,4.59-.91,6.94-1.26l5.68-.83a124.79,124.79,0,0,0,20.59-4.91,160.43,160.43,0,0,0,20.34-8.53c7-3.4,14.71-7.32,23.06-10.58A132.2,132.2,0,0,1,205,26.27c2.18-.6,4.38-1.13,6.58-1.62l3.31-.67c1.25-.23,2.5-.43,3.77-.59a54.87,54.87,0,0,1,15.61.17,46.59,46.59,0,0,1,15.33,5.14,41.18,41.18,0,0,1,12.6,10.64,38.59,38.59,0,0,1,7.14,14.59,41.39,41.39,0,0,1,.82,15.37,50,50,0,0,1-3.9,13.85A77.11,77.11,0,0,1,251,105a94.53,94.53,0,0,1-9.6,8.66,110.67,110.67,0,0,1-10.54,7.24c-14.53,8.78-30.45,13.8-45,20.16-7.28,3.13-14.29,6.68-19.8,11.07a34.19,34.19,0,0,0-6.75,7.15c-.43.64-.83,1.28-1.2,1.93s-.7,1.29-1.05,2c-.68,1.42-1.34,3-2,4.64-1.24,3.29-2.33,6.88-3.34,10.55s-2,7.43-3,11.23l-2.91,11.53c-1,3.87-2,7.77-3.06,11.68-4.32,15.61-9.34,31.45-17,46.92a113.55,113.55,0,0,1-14.5,22.48c-1.53,1.76-3.12,3.5-4.87,5.18a52.9,52.9,0,0,1-5.56,4.79,49,49,0,0,1-6.42,4.14A38.19,38.19,0,0,1,90.87,298l-1.84.72c-.59.22-1.11.37-1.67.56a64.58,64.58,0,0,1-13.65,2.86,48.8,48.8,0,0,1-14.11-.63,40.43,40.43,0,0,1-13.1-5,36.35,36.35,0,0,1-5.57-4,38.17,38.17,0,0,1-4.71-4.81,52,52,0,0,1-10.45-23.22A83.75,83.75,0,0,1,24.9,239.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,440.15a105,105,0,0,0-26.5,7.85c-8.53,3.64-16.74,8-25,12.48-4.16,2.2-8.31,4.49-12.61,6.62a129.23,129.23,0,0,1-13.44,6,63.78,63.78,0,0,1-15.35,3.76,40.12,40.12,0,0,1-17.85-2c-1.51-.55-3-1.27-4.45-1.94s-2.8-1.62-4.19-2.48-2.58-1.92-3.83-2.93-2.31-2.14-3.45-3.24a62.3,62.3,0,0,1-10.52-14.57,71.9,71.9,0,0,1-6.14-16.52,100.33,100.33,0,0,1-2.45-16.42,209.65,209.65,0,0,1,.56-30.39l1.13-14.11c.19-2.3.32-4.57.47-6.83l.2-3.37.13-3.32a125.68,125.68,0,0,0-.19-12.92,71.18,71.18,0,0,0-1.77-12.11,72.34,72.34,0,0,0-4.28-12.13c-1.81-4.12-3.89-8.28-6.14-12.44-4.5-8.36-9.6-16.69-14.58-25.31l-3.69-6.52c-1.2-2.22-2.39-4.44-3.52-6.73a100.35,100.35,0,0,1-6-14.3,50.87,50.87,0,0,1-2.69-15.88,36.48,36.48,0,0,1,3.73-15.88,41.25,41.25,0,0,1,4.22-6.73l2.47-3c.84-1,1.72-1.81,2.58-2.72a81.39,81.39,0,0,1,11.49-9.59,78,78,0,0,1,13.27-7.13c1.17-.45,2.32-1,3.52-1.39l3.59-1.22c2.42-.69,4.86-1.38,7.34-1.88a102.57,102.57,0,0,1,30.28-1.69,131.63,131.63,0,0,1,15.07,2.11c5,.93,9.9,2.23,14.77,3.65,2.41.76,4.86,1.46,7.23,2.32l3.59,1.25,3.55,1.35q7.08,2.75,13.92,6c2.28,1.1,4.53,2.23,6.79,3.36s4.46,2.37,6.66,3.6,4.4,2.47,6.55,3.78,4.32,2.6,6.42,4l12.13,7.85c2,1.28,4,2.48,6,3.73l3,1.85,3,1.79a455.36,455.36,0,0,0,49.41,25.52c8.52,3.78,17.13,7.41,26.24,11.52,4.54,2,9.21,4.33,14,7a94.06,94.06,0,0,1,14.47,10,73.49,73.49,0,0,1,12.65,13.87,85.08,85.08,0,0,1,8.63,15.69c1.2,2.64,2.11,5.24,3.07,7.86.46,1.3.85,2.59,1.27,3.88s.84,2.57,1.18,4l1.08,4.09.52,2.05.4,2.13a73,73,0,0,1,1.27,8.58c.14,1.46.28,2.92.38,4.38V363c0,.74-.12,1.5-.18,2.25l-.46,4.49c-.22,1.49-.57,3-.87,4.45l-.47,2.21c-.18.73-.43,1.46-.65,2.18-.45,1.44-.89,2.89-1.38,4.3s-1.19,2.77-1.8,4.13a57.49,57.49,0,0,1-9.67,14.46l-1.4,1.58c-.49.5-1,1-1.5,1.45-1,.95-2,1.91-3,2.81-2.14,1.67-4.2,3.45-6.44,4.86a91.94,91.94,0,0,1-13.53,7.55,131.08,131.08,0,0,1-14,5.29,232,232,0,0,1-28.15,6.86c-2.35.41-4.69.89-7,1.24s-4.67.83-7,1.16-4.69.71-7,1.06l-7,1Zm-.52-3.06c9.27-1.34,18.47-3,27.54-5.2l3.4-.81,3.38-.9c2.25-.57,4.48-1.26,6.7-1.93,4.46-1.3,8.84-2.82,13.16-4.44a151.67,151.67,0,0,0,24.68-11.75,114.27,114.27,0,0,0,11-7.42,78.44,78.44,0,0,0,9.34-8.56c1.47-1.45,2.62-3.1,3.9-4.62l1.67-2.41c.27-.4.56-.79.82-1.2l.69-1.24A39.34,39.34,0,0,0,446,376.53c.2-.87.4-1.72.64-2.56l.39-2.62c.06-.44.15-.86.19-1.3l.05-1.34c0-.9.12-1.77.13-2.66l-.1-2.72c0-.45,0-.89-.05-1.35l-.17-1.39-.3-2.76-.55-2.82A80.37,80.37,0,0,0,443,343.55c-.28-.95-.69-2-1.08-3s-.76-2-1.17-3c-.85-1.89-1.64-3.85-2.55-5.6a56.69,56.69,0,0,0-5.82-9.61,42.94,42.94,0,0,0-7.16-7.35c-5.39-4.38-12.8-8.21-21.15-12.15-4.15-2-8.47-3.94-12.86-6s-8.82-4.19-13.24-6.35a422.5,422.5,0,0,1-51.52-30.23l-3.09-2.09-3-2.15c-2-1.44-4.07-2.85-6.07-4.32l-11.68-8.62c-3.72-2.73-7.5-5.37-11.29-8l-5.74-3.81c-1.93-1.22-3.86-2.46-5.81-3.67-3.91-2.34-7.82-4.72-11.83-6.84l-3-1.63-3-1.55c-2-1.06-4.06-2-6.11-2.95a139,139,0,0,0-25.27-8.88,95.16,95.16,0,0,0-13-2.11,68.35,68.35,0,0,0-13,0A58.76,58.76,0,0,0,180,211.33a59.66,59.66,0,0,0-10.41,7.82c-.77.77-1.6,1.51-2.34,2.29l-2.08,2.36a32.7,32.7,0,0,0-3.33,5.17,24.54,24.54,0,0,0-2.73,11.72,36.43,36.43,0,0,0,2.66,12.52,78.4,78.4,0,0,0,6.2,12.17c2.46,3.94,5.16,7.82,8.05,11.62,5.73,7.63,12,15.08,18.16,23,3.07,4,6.08,8.12,8.94,12.54a95.55,95.55,0,0,1,7.82,14.39c4.54,10.75,6.29,21.63,7,32.09,1.37,20.88-1.3,40.09-.91,57.31.18,8.59,1.12,16.52,3.62,23.54a44.52,44.52,0,0,0,5.05,10,23.71,23.71,0,0,0,6.84,7,23.46,23.46,0,0,0,9.88,3.38,48.82,48.82,0,0,0,12.43-.28,117.12,117.12,0,0,0,13.21-2.67c4.42-1.21,8.88-2.54,13.3-4,8.88-2.9,17.7-6.21,26.66-9.15A166.85,166.85,0,0,1,335.52,437.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.15,89a68.75,68.75,0,0,1,9.1-1.64c1.46-.19,2.88-.3,4.31-.43s2.83-.16,4.22-.19c2.78-.1,5.49,0,8.2.06,10.74.43,21,2.07,31.14,3.64l3.59.54,1.59.23,1.63.13c1.09.1,2.22.07,3.34.1s2.28-.1,3.45-.19,2.32-.21,3.51-.4,2.35-.35,3.55-.59c2.36-.48,4.78-1,7.16-1.66,9.64-2.54,19.17-6.32,29.81-8.75a54.56,54.56,0,0,1,17.17-1.3,39.47,39.47,0,0,1,13.47,3.82c.71.35,1.44.68,2.13,1l2,1.19A55,55,0,0,1,450,90.14c1.18,1,2.3,2.26,3.44,3.43s2.05,2.49,3.07,3.76,1.78,2.63,2.66,4c.45.68.8,1.37,1.16,2l1.1,2.08.54,1.06.45,1.06.88,2.14a38.48,38.48,0,0,1,1.56,4.32A70.67,70.67,0,0,1,468,131.49a84.46,84.46,0,0,1-.94,17.16A83.52,83.52,0,0,1,462.64,165c-.51,1.31-1.05,2.61-1.6,3.89s-1.2,2.55-1.81,3.8-1.27,2.5-2,3.72-1.36,2.43-2.13,3.62a102.83,102.83,0,0,1-9.95,13.37,101.27,101.27,0,0,1-11.7,11.47A85.63,85.63,0,0,1,420.36,214a54.3,54.3,0,0,1-14.7,5.65,35.11,35.11,0,0,1-16-.38,59.56,59.56,0,0,1-15-6.35,158.74,158.74,0,0,1-26-19.47c-4-3.6-7.75-7.35-11.31-11.2a8.34,8.34,0,0,0-1.11-1l-.93-.81c-.72-.49-1.27-1-2-1.5l-1-.72c-.37-.23-.75-.44-1.1-.68-.69-.48-1.55-.88-2.27-1.35a98,98,0,0,0-11-5.14l-6.58-2.59-3.52-1.37-3.67-1.52c-2.49-1-5.11-2.27-7.77-3.59a75,75,0,0,1-8.24-4.91,52.45,52.45,0,0,1-8.24-7,43.51,43.51,0,0,1-6.87-9.56l-.72-1.32-.61-1.35c-.39-.91-.8-1.82-1.16-2.74a46.32,46.32,0,0,1-1.62-5.54l-.57-2.76-.35-2.68a45.48,45.48,0,0,1-.34-5.26c0-.46,0-.81,0-1.34,0-.71,0-1.4.09-2.09a24.09,24.09,0,0,1,.63-4.32c.07-.35.16-.72.25-1.08l.35-1.1c.24-.72.51-1.44.78-2.15a28.78,28.78,0,0,1,2.13-4c.41-.61.83-1.2,1.27-1.78.22-.29.44-.59.66-.85l.69-.77c.45-.49.92-1,1.41-1.46s.93-.84,1.42-1.26,1-.79,1.45-1.15l1.41-1c.47-.3,1-.64,1.42-.9l1.37-.76A47.56,47.56,0,0,1,293.15,89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,354a50.4,50.4,0,0,1,.71,10.09c-.09,6.46-1.55,12.37-3.14,18.14a116.67,116.67,0,0,1-6.05,16.8,74.27,74.27,0,0,1-9.35,15.3,70,70,0,0,1-13.41,13,44.23,44.23,0,0,1-18.92,7.53,42.28,42.28,0,0,1-10.9.22,34.83,34.83,0,0,1-10.15-2.73,35.58,35.58,0,0,1-8-4.94,69.86,69.86,0,0,1-6.16-5.78,25.1,25.1,0,0,1-2.69-3.53A28,28,0,0,1,56.79,414a45.49,45.49,0,0,1-2-9,76.72,76.72,0,0,1-.21-19.1,43.19,43.19,0,0,1,5.81-17.24A43.74,43.74,0,0,1,72.21,356c4.73-3.44,10.29-5.91,15.72-8.16s10.87-4.25,15.94-6.65,10-5.06,16.18-7a28.36,28.36,0,0,1,5.06-1.09,20.46,20.46,0,0,1,6,.09,15.88,15.88,0,0,1,7.25,3.53,19.78,19.78,0,0,1,1.46,1.43c.43.49.86,1,1.27,1.52A24.38,24.38,0,0,1,143,342.7a29.65,29.65,0,0,1,1.4,3c.35.93.74,2,1,2.85l.41,1.41.33,1.37C146.4,352.25,146.55,353.11,146.71,354Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--number-2--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.11,230.37a12.24,12.24,0,0,1-12.44,12.22h-2.23v16.88a12.22,12.22,0,0,1-24.43,0V242.59H343a10.88,10.88,0,0,1-7.55-2.67,11.88,11.88,0,0,1-2-17.1l82.18-102.18c.23,0,.23-.22.45-.44a3.47,3.47,0,0,0,.67-.89,2.48,2.48,0,0,0,1.11-.67c.22-.22.66-.44.89-.67a2.37,2.37,0,0,1,1.33-.44c.22-.44.44-.67.89-.67.22-.22.66-.22,1.33-.44a1.35,1.35,0,0,0,.89-.22H427a2,2,0,0,0,1.11.22c.23.22.89.22,1.34.44.22,0,.67.23.89.23.44.44.88.66,1.1.88.45.23.67.45,1.12.67a.22.22,0,0,1,.22.22c.22,0,.67.22.67.45l.88.89c.23.22.45.66.67.88a6.52,6.52,0,0,1,.89,1.11,1.61,1.61,0,0,0,.45.89,9.55,9.55,0,0,1,.44,1.34c0,.22.22.66.22.88a2.46,2.46,0,0,1,.22,1.34c0,.44.22.66.22,1.11v90.4h2.23A12.38,12.38,0,0,1,452.11,230.37ZM413,163.29,368.8,218.15H413Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planet--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.86,189l2.26-12.67a6.67,6.67,0,0,0-5.39-7.73h0A6.67,6.67,0,0,0,169,174l-2.26,12.66a6.68,6.68,0,0,0,5.39,7.74h0A6.67,6.67,0,0,0,179.86,189Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.3,191.94l-1.84-12.74a6.66,6.66,0,0,0-7.55-5.64h0a6.66,6.66,0,0,0-5.64,7.55l1.83,12.73a6.68,6.68,0,0,0,7.56,5.65h0A6.67,6.67,0,0,0,333.3,191.94Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.76,142.45l5.05-4.72a6.67,6.67,0,0,0,.33-9.42h0a6.68,6.68,0,0,0-9.43-.33l-5.05,4.72a6.66,6.66,0,0,0-.32,9.42h0A6.67,6.67,0,0,0,201.76,142.45Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.83,247.51l-4.71-5a6.67,6.67,0,0,0-9.43-.33h0a6.67,6.67,0,0,0-.32,9.42l4.71,5.06a6.68,6.68,0,0,0,9.43.32h0A6.67,6.67,0,0,0,208.83,247.51Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.33,
    y: 146.15,
    width: 20.24,
    height: 13.33,
    rx: 2.16,
    transform: "translate(259.59 -191.72) rotate(55.12)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.34,271.1l6.5-2.35a6.66,6.66,0,0,0,4-8.53h0a6.66,6.66,0,0,0-8.53-4l-6.5,2.35a6.68,6.68,0,0,0-4,8.54h0A6.68,6.68,0,0,0,276.34,271.1Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.29,
    cy: 193.32,
    r: 76.92,
    transform: "translate(-29.43 45.75) rotate(-9.87)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,135.1a17.24,17.24,0,0,1,3.64,10.19A20.82,20.82,0,0,1,244,156.13a15.27,15.27,0,0,1-8.71,7.25,15.87,15.87,0,0,1-10.85-.51,22.75,22.75,0,0,0,9.9-1.94,13.54,13.54,0,0,0,3.88-2.69,15.3,15.3,0,0,0,2.85-3.75c.38-.7.76-1.44,1.1-2.18s.63-1.51.84-2.29a22.21,22.21,0,0,0,1-4.79A26.4,26.4,0,0,0,243,135.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.83,154.54a11,11,0,0,1-2.89-6.95,13.77,13.77,0,0,1,1.74-7.63,10.4,10.4,0,0,1,6.25-5.06,10.2,10.2,0,0,1,7.53.73,17.2,17.2,0,0,0-6.59,1.71,10.5,10.5,0,0,0-4.26,4.25A18.21,18.21,0,0,0,222.83,154.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.63,239.39a7.66,7.66,0,0,1,1,5.27,9.34,9.34,0,0,1-2.48,5,7.34,7.34,0,0,1-5.24,2.37,7.53,7.53,0,0,1-5.07-1.8,13.7,13.7,0,0,0,4.85-.11,7.18,7.18,0,0,0,3.67-2.15,11.45,11.45,0,0,0,2.41-3.79A13.9,13.9,0,0,0,250.63,239.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.15,247.57a5,5,0,0,1-1-3.66,6.38,6.38,0,0,1,1.71-3.62,5.15,5.15,0,0,1,3.81-1.65,4.83,4.83,0,0,1,3.49,1.54,10.76,10.76,0,0,0-3.27.38,5.19,5.19,0,0,0-2.24,1.42A9.54,9.54,0,0,0,240.15,247.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,219.3a6.84,6.84,0,0,1,4.62,2.79,7.54,7.54,0,0,1,1.32,5.71,6.71,6.71,0,0,1-3.52,4.8,8,8,0,0,1-5.29.87,25.24,25.24,0,0,0,3.74-3,6,6,0,0,0,1.76-3.25,7.86,7.86,0,0,0-.31-3.85A14.21,14.21,0,0,0,203.42,219.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,230.87a4.39,4.39,0,0,1-3.52-1.7,5.26,5.26,0,0,1-1.06-4.17,4.8,4.8,0,0,1,2.68-3.52,5,5,0,0,1,3.85-.25,24.48,24.48,0,0,0-2.3,2.38,4.07,4.07,0,0,0-.92,2,6,6,0,0,0,.06,2.33A11,11,0,0,0,199.87,230.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.22,141.84a6.86,6.86,0,0,1,1.6,5.17,7.52,7.52,0,0,1-2.8,5.14,6.75,6.75,0,0,1-5.82,1.25,8,8,0,0,1-4.53-2.87,25.18,25.18,0,0,0,4.78.24,5.93,5.93,0,0,0,3.47-1.25,7.75,7.75,0,0,0,2.33-3.09A14.1,14.1,0,0,0,290.22,141.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.88,148.14a4.4,4.4,0,0,1-1.5-3.61,5.25,5.25,0,0,1,2-3.82,4.79,4.79,0,0,1,4.33-.86,5.06,5.06,0,0,1,3.05,2.38,24.07,24.07,0,0,0-3.3.25,4.13,4.13,0,0,0-2,.85,5.94,5.94,0,0,0-1.51,1.78A11.47,11.47,0,0,0,279.88,148.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.36,207.87a17,17,0,1,0-19.85-13.55A17,17,0,0,0,271.36,207.87Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.36,207.87a17,17,0,1,0-19.85-13.55A17,17,0,0,0,271.36,207.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.11,180a15.32,15.32,0,0,1,13.4,3.89,17,17,0,1,0-19.63,23.71,15.47,15.47,0,0,1,6.23-27.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.08,180a22,22,0,0,1,4.18,12.58,25.91,25.91,0,0,1-3.29,13.2,18.73,18.73,0,0,1-10.53,8.85,20.16,20.16,0,0,1-13.27-.33,27.15,27.15,0,0,0,12.33-2.11,26.72,26.72,0,0,0,2.63-1.45,16.67,16.67,0,0,0,2.29-1.89,18.83,18.83,0,0,0,3.62-4.71c.48-.89.95-1.81,1.37-2.74s.78-1.89,1-2.87a27.14,27.14,0,0,0,1.2-6A31,31,0,0,0,289.08,180Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,174.69a6.36,6.36,0,1,0-8.23-3.54A6.33,6.33,0,0,0,308.05,174.69Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,174.69a6.36,6.36,0,1,0-8.23-3.54A6.33,6.33,0,0,0,308.05,174.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.61,164.58a5.69,5.69,0,0,1,5.18.47,6.33,6.33,0,1,0-5.5,10.08,5.77,5.77,0,0,1,.32-10.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.56,163.24a7.9,7.9,0,0,1,2.59,4.28,9.54,9.54,0,0,1-.23,5.16,7,7,0,0,1-3.34,4.07,7.24,7.24,0,0,1-5,.68,10.83,10.83,0,0,0,4.28-1.79,7,7,0,0,0,2.44-3.48A11.52,11.52,0,0,0,312.56,163.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.8,233.42a9,9,0,1,0-12.4-2.94A9,9,0,0,0,295.8,233.42Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.8,233.42a9,9,0,1,0-12.4-2.94A9,9,0,0,0,295.8,233.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.89,219.86a8.12,8.12,0,0,1,7.37-.61A9,9,0,1,0,292,234.71a8.21,8.21,0,0,1-2.15-14.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.28,216.28a11.77,11.77,0,0,1,4.42,5.45,13.77,13.77,0,0,1,.87,7.13,10,10,0,0,1-3.51,6.36,10.82,10.82,0,0,1-6.61,2.38,14.1,14.1,0,0,0,5.73-3.35,9.75,9.75,0,0,0,2.72-5.63,15,15,0,0,0-.43-6.46A16,16,0,0,0,299.28,216.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,185.13c.2,6.94-6,12.76-13.83,13S184,192.92,183.79,186s6-12.76,13.82-13S212,178.18,212.19,185.13Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,185.13c.2,6.94-6,12.76-13.83,13S184,192.92,183.79,186s6-12.76,13.82-13S212,178.18,212.19,185.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.27,188.79a11,11,0,0,0,5.56,9.05c-6.18-1.2-10.88-6-11.05-11.87-.21-6.94,6-12.76,13.83-13a14.44,14.44,0,0,1,13,6.79,13.7,13.7,0,0,0-8.82-2.77C194.71,177.2,189.08,182.49,189.27,188.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5,174.6a13.5,13.5,0,0,1,7.38,7.35,12.61,12.61,0,0,1,1,5.47,15.77,15.77,0,0,1-1.21,5.45,15.23,15.23,0,0,1-3.33,4.51,17.29,17.29,0,0,1-4.53,3,22.17,22.17,0,0,1-10.17,2.06,43.92,43.92,0,0,0,9-4.21,16.06,16.06,0,0,0,6.18-6.62,13.86,13.86,0,0,0,1.11-4.35,12,12,0,0,0-.31-4.5A17.73,17.73,0,0,0,210.5,174.6Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--number-1--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.24,230.37a12.24,12.24,0,0,1-12.44,12.22h-2.22v16.88a12.22,12.22,0,0,1-24.43,0V242.59h-70a10.88,10.88,0,0,1-7.55-2.67,11.88,11.88,0,0,1-2-17.1l82.18-102.18c.23,0,.23-.22.45-.44a3.47,3.47,0,0,0,.67-.89,2.54,2.54,0,0,0,1.11-.67c.22-.22.66-.44.89-.67a2.37,2.37,0,0,1,1.33-.44c.22-.44.44-.67.89-.67.22-.22.66-.22,1.33-.44a1.36,1.36,0,0,0,.89-.22h3.77a2,2,0,0,0,1.11.22c.22.22.89.22,1.34.44.22,0,.66.23.89.23.44.44.88.66,1.1.88.45.23.67.45,1.12.67a.22.22,0,0,1,.22.22c.22,0,.67.22.67.45l.88.89c.22.22.45.66.67.88a7.07,7.07,0,0,1,.89,1.11,1.66,1.66,0,0,0,.44.89,8.29,8.29,0,0,1,.45,1.34c0,.22.22.66.22.88a2.46,2.46,0,0,1,.22,1.34c0,.44.22.66.22,1.11v90.4h2.22A12.38,12.38,0,0,1,169.24,230.37Zm-39.09-67.08L86,218.15h44.2Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "260.78 410.36 264.84 411.11 265.75 415.38 266.65 411.11 270.71 410.35 266.67 409.37 265.75 405.32 264.82 409.37 260.78 410.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.97 260.06 174.03 260.81 174.93 265.09 175.84 260.81 179.9 260.06 175.86 259.07 174.93 255.03 174.01 259.07 169.97 260.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.48 258.29 399.54 259.04 400.45 263.32 401.36 259.04 405.42 258.29 401.37 257.3 400.45 253.26 399.52 257.3 395.48 258.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.36 372.85 441.63 373.27 442.14 375.66 442.64 373.27 444.91 372.85 442.65 372.3 442.14 370.04 441.62 372.3 439.36 372.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.3 95.17 410.56 95.59 411.07 97.98 411.58 95.59 413.85 95.17 411.59 94.62 411.07 92.36 410.56 94.62 408.3 95.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453 166.29 455.27 166.71 455.77 169.1 456.28 166.71 458.55 166.29 456.29 165.74 455.77 163.48 455.26 165.74 453 166.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.58 198.36 108.85 198.78 109.35 201.17 109.86 198.78 112.13 198.36 109.87 197.81 109.35 195.55 108.84 197.81 106.58 198.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.7 384.69 50.97 385.11 51.48 387.5 51.99 385.11 54.26 384.69 52 384.13 51.48 381.88 50.96 384.13 48.7 384.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.06 325.78 427.32 326.2 427.83 328.59 428.34 326.2 430.61 325.77 428.35 325.22 427.83 322.96 427.31 325.22 425.06 325.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.68 398.49 117.95 398.91 118.46 401.3 118.96 398.91 121.23 398.49 118.97 397.94 118.46 395.68 117.94 397.94 115.68 398.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.59 104.87 197.86 105.28 198.37 107.68 198.88 105.28 201.14 104.86 198.88 104.31 198.37 102.05 197.85 104.31 195.59 104.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.91 171.92 332.18 172.34 332.69 174.73 333.19 172.34 335.46 171.91 333.2 171.36 332.69 169.1 332.17 171.36 329.91 171.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.64 351.77 151.91 352.19 152.41 354.58 152.92 352.19 155.19 351.77 152.93 351.22 152.41 348.96 151.9 351.22 149.64 351.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.48,425.74a.66.66,0,0,1,0,1.32A.66.66,0,0,1,51.48,425.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.14,345.68a.66.66,0,0,1,0,1.32A.66.66,0,0,1,379.14,345.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.36,251.65a.66.66,0,0,1,0,1.31A.66.66,0,0,1,385.36,251.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.36,203.16a.66.66,0,0,1,0,1.32A.66.66,0,0,1,339.36,203.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.33,434.64a.66.66,0,0,1,0,1.31A.66.66,0,0,1,136.33,434.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.35,396.52a.66.66,0,0,1,0,1.31A.66.66,0,0,1,109.35,396.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.14,379.06a.66.66,0,0,1,0,1.32A.66.66,0,0,1,177.14,379.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.66,396.52a.66.66,0,0,1,0,1.31A.66.66,0,0,1,301.66,396.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.44,354.3a.66.66,0,0,1,0,1.31A.66.66,0,0,1,410.44,354.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.92,281.55a.66.66,0,0,1,0,1.32A.66.66,0,0,1,382.92,281.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.23,395.21a.47.47,0,0,1,0,.93A.47.47,0,0,1,271.23,395.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5,106.66a.47.47,0,0,1,0,.93A.47.47,0,0,1,127.5,106.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,340.91a.47.47,0,0,1,0,.93A.47.47,0,0,1,308,340.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.67,400.83a.47.47,0,0,1,0,.93A.47.47,0,0,1,128.67,400.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.64,288.59a.47.47,0,0,1,0,.93A.47.47,0,0,1,247.64,288.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.26,293.94a1.26,1.26,0,0,1,0,2.52A1.26,1.26,0,0,1,348.26,293.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.54 120.16 175.59 120.91 176.5 125.19 177.41 120.91 181.47 120.16 177.43 119.17 176.5 115.13 175.58 119.17 171.54 120.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.19 154.51 346.25 155.26 347.16 159.54 348.06 155.26 352.12 154.51 348.08 153.52 347.16 149.48 346.23 153.52 342.19 154.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.52 257.11 50.57 257.86 51.48 262.14 52.39 257.86 56.45 257.11 52.41 256.12 51.48 252.08 50.56 256.12 46.52 257.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.11 53.3 410.17 54.05 411.07 58.33 411.98 54.05 416.04 53.29 412 52.31 411.07 48.27 410.15 52.31 406.11 53.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.19 62.95 262.46 63.37 262.97 65.76 263.48 63.37 265.75 62.95 263.49 62.4 262.97 60.14 262.45 62.4 260.19 62.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.48 142.84 53.75 143.26 54.26 145.65 54.76 143.26 57.03 142.84 54.77 142.29 54.26 140.03 53.74 142.29 51.48 142.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.15,138.87a.66.66,0,0,1,0,1.32A.66.66,0,0,1,93.15,138.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.14,374.45a.66.66,0,0,1,0,1.32A.66.66,0,0,1,43.14,374.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09,351.77a.66.66,0,0,1,0,1.31A.66.66,0,0,1,97.09,351.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.78,185.25a.66.66,0,0,1,0,1.31A.66.66,0,0,1,43.78,185.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09,86.36a.66.66,0,0,1,0,1.32A.66.66,0,0,1,97.09,86.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.21,52.64a.66.66,0,0,1,0,1.31A.66.66,0,0,1,183.21,52.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,287.8a.47.47,0,0,1,0,.93A.47.47,0,0,1,156.79,287.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,407.63a.47.47,0,0,1,0,.93A.47.47,0,0,1,156.34,407.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394 134.23 396.27 134.65 396.77 137.04 397.28 134.65 399.55 134.23 397.29 133.68 396.77 131.42 396.26 133.68 394 134.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.77 252.98 447.04 253.4 447.55 255.79 448.06 253.4 450.32 252.97 448.07 252.42 447.55 250.16 447.03 252.42 444.77 252.98",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,136.49a.66.66,0,0,1,0,1.31A.66.66,0,0,1,387.67,136.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.5,70.75a.47.47,0,0,1,0,.93A.47.47,0,0,1,320.5,70.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.55,450.8a.47.47,0,0,1,0,.93A.47.47,0,0,1,221.55,450.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.66,147.6a.47.47,0,0,1,0,.93A.47.47,0,0,1,434.66,147.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.06,124.73a.47.47,0,0,1,0,.93A.47.47,0,0,1,341.06,124.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4,53.49a.47.47,0,0,1,0,.93A.47.47,0,0,1,342.4,53.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.07,271.27a1.26,1.26,0,0,1,0,2.52A1.26,1.26,0,0,1,212.07,271.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.14,206.74a1.27,1.27,0,0,1,0,2.53A1.27,1.27,0,0,1,384.14,206.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.23,208a1.26,1.26,0,0,1,0,2.52A1.26,1.26,0,0,1,99.23,208Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.13,215.61a1.26,1.26,0,0,1,0,2.52A1.26,1.26,0,0,1,446.13,215.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,331a1.26,1.26,0,0,1,0,2.52A1.26,1.26,0,0,1,81.66,331Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.25 84.87 147.51 85.28 148.02 87.68 148.53 85.28 150.8 84.86 148.54 84.31 148.02 82.05 147.51 84.31 145.25 84.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.95 322.63 271.21 323.05 271.72 325.44 272.23 323.05 274.5 322.63 272.24 322.07 271.72 319.81 271.21 322.07 268.95 322.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.19,431.94a.66.66,0,0,1,0,1.32A.66.66,0,0,1,342.19,431.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.6,425.74a.66.66,0,0,1,0,1.32A.66.66,0,0,1,298.6,425.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.63 250 314.89 250.42 315.4 252.81 315.91 250.42 318.18 250 315.92 249.45 315.4 247.19 314.88 249.45 312.63 250",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.38 386.33 392.65 386.75 393.16 389.14 393.66 386.75 395.93 386.33 393.67 385.78 393.16 383.52 392.64 385.78 390.38 386.33",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.07 443.65 413.34 444.07 413.85 446.46 414.36 444.07 416.62 443.65 414.37 443.09 413.85 440.83 413.33 443.09 411.07 443.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.2,123.88a.66.66,0,0,1,0,1.31A.66.66,0,0,1,322.2,123.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.93,416.52a.47.47,0,0,1,0,.93A.47.47,0,0,1,395.93,416.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.31 271.27 70.58 271.69 71.09 274.08 71.59 271.69 73.86 271.27 71.6 270.71 71.09 268.46 70.57 270.71 68.31 271.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.08,320a.66.66,0,0,1,0,1.31A.66.66,0,0,1,42.08,320Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,216.21a.66.66,0,0,1,0,1.32A.66.66,0,0,1,204.56,216.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,143.42a.47.47,0,0,1,0,.93A.47.47,0,0,1,156.34,143.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.44,61.69a1.26,1.26,0,0,1,0,2.52A1.26,1.26,0,0,1,80.44,61.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.33,89.84a1.26,1.26,0,0,1,0,2.52A1.26,1.26,0,0,1,379.33,89.84Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.65,440.84a66.87,66.87,0,0,1-17.21-2.29c-14.23-3.79-25.15-12.33-31.59-24.69-7.53-14.47-7.4-30.79-4.1-39.84l2.82,1c-3.19,8.72-2.86,24.37,3.94,37.42,6,11.6,16.31,19.62,29.7,23.18,19.23,5.12,38.81,1.12,53.73-11,16.56-13.43,24.95-34.82,23.62-60.23s-13.05-56.07-25.45-88.56c-12-31.35-24.33-63.76-26.92-91.74-2.69-29.07,5.29-55,23.06-75C421,84.65,456.81,70.56,500,69.48l.08,3c-42.32,1.06-77.32,14.79-98.54,38.67-17.21,19.35-24.93,44.5-22.32,72.73,2.55,27.56,14.84,59.78,26.74,90.94,12.48,32.72,24.28,63.62,25.63,89.48,1.38,26.39-7.4,48.66-24.72,62.71A61.86,61.86,0,0,1,367.65,440.84Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,355.55c-.31.72,17.93,38.85,19.37,40.38a1.22,1.22,0,0,0,.23.19c2.16,1.7,16.59,7.37,17.75,7.76,2.87.95,31.64-43.37,33.84-51.22.55-2-11.27-25.36-15.29-28.58-1.72-1.38-8.25-3.57-9.08-3.3h0C333.66,321.23,288.32,354.83,288,355.55Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,355.55c-.31.72,17.93,38.85,19.37,40.38a1.22,1.22,0,0,0,.23.19c2.16,1.7,16.59,7.37,17.75,7.76,2.87.95,31.64-43.37,33.84-51.22.55-2-11.27-25.36-15.29-28.58-1.72-1.38-8.25-3.57-9.08-3.3h0C333.66,321.23,288.32,354.83,288,355.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,355.55c-.31.72,17.93,38.85,19.37,40.38a1.22,1.22,0,0,0,.23.19c7.43-8.23,42.24-46.94,42.27-47.56S338,325.89,334.83,320.78C333.66,321.23,288.32,354.83,288,355.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.31,324.46l-35.44,4.91c-6.77,1-12.72,1.7-15.83,1.79h0a4.79,4.79,0,0,1-2.16-.2s0,0-.05,0c-1.66-1.81-11-55.67-10.71-57.66s6-1.27,8,.53,14.84,20.82,14.84,20.82l35.44-4.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,332l-.53-2.78a2.63,2.63,0,0,0,.86-.38,2.77,2.77,0,0,0-1.89-5l-.49-2.52a2.63,2.63,0,0,0,.89-.4,2.75,2.75,0,0,0-1.92-5l-.49-2.52A2.71,2.71,0,0,0,123,313a2.75,2.75,0,0,0-2-5l-.48-2.52a2.79,2.79,0,0,0,.95-.43,2.75,2.75,0,0,0-2-5L119,297.5a2.58,2.58,0,0,0,1-.42,2.76,2.76,0,0,0-2-5l-.48-2.51a2.68,2.68,0,0,0,1-.43,2.76,2.76,0,0,0,.7-3.83,2.79,2.79,0,0,0-2.76-1.16l-.48-2.52a2.47,2.47,0,0,0,1-.43,2.75,2.75,0,0,0-2.09-5l-.45-2.37,5.58-.6L130.83,331Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,328.75a11.59,11.59,0,0,0-4.32-8.28,11.24,11.24,0,0,0-8-2.5c-.08,0-.07.17,0,.18a13.41,13.41,0,0,1,12.11,10.61A.09.09,0,0,0,142.51,328.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29,327c-.24-3.94-.81-7.86-1.41-11.76s-1.21-7.72-1.86-11.57c-.37-2.21-.74-4.42-1.22-6.6a.12.12,0,0,0-.23,0c.29,3.93.89,7.85,1.41,11.76s1.07,7.74,1.69,11.6c.36,2.21.77,4.4,1.29,6.59A.17.17,0,0,0,149.29,327Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.28,326.18c-.24-3.95-.81-7.86-1.41-11.76s-1.21-7.72-1.86-11.58c-.36-2.2-.74-4.41-1.22-6.6a.12.12,0,0,0-.23,0c.29,3.94.89,7.85,1.41,11.76s1.07,7.74,1.69,11.6c.36,2.22.77,4.41,1.29,6.59A.17.17,0,0,0,152.28,326.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.44,327.9l-4-34.88a19,19,0,0,1,10.14-4.85c14.77-2.56,41.81-3.47,57.56-.7,13.29,2.33,55.49,41.93,62.13,47.18,2.43,1.91,8.07-1.53,8.07-1.53l19.22,39.32s-15.16,10.16-30.17,1.35c-18.48-10.85-56.42-49.07-63.92-50.62-6.78-1.4-35.81,5.35-50.45,7.14A11.71,11.71,0,0,1,159.44,327.9Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54,324.83c-.08-3.95-.5-7.89-.95-11.81s-.9-7.76-1.39-11.63c-.29-2.22-.57-4.45-1-6.65a.12.12,0,0,0-.23,0c.14,3.94.58,7.88.95,11.81s.76,7.78,1.23,11.65c.27,2.23.59,4.44,1,6.64A.17.17,0,0,0,164.54,324.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,301.74a6.43,6.43,0,0,0-2.26,1.89,13.33,13.33,0,0,0-1.58,2.5,21.7,21.7,0,0,0-1.82,5.56c-.19.95-.3,1.91-.41,2.87s-.13,1.92-.11,2.88.07,1.92.17,2.88a27.82,27.82,0,0,0,.49,2.85c.27-.94.45-1.88.62-2.81s.37-1.85.51-2.77.33-1.84.47-2.75l.25-1.36c.08-.46.14-.92.24-1.36.35-1.8.75-3.58,1.25-5.33A16.56,16.56,0,0,1,224,301.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.46,
    cy: 295.2,
    rx: 9.24,
    ry: 13.02,
    transform: "translate(-142.41 343.79) rotate(-60.01)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.46,
    cy: 295.2,
    rx: 9.24,
    ry: 13.02,
    transform: "translate(-142.41 343.79) rotate(-60.01)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.55,372.44s-15.16,10.16-30.17,1.35c-18.47-10.85-56.41-49.07-63.92-50.62-6.78-1.4-35.8,5.36-50.45,7.14a11.71,11.71,0,0,1-8.57-2.41l-3.68-32L302.57,352Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.32,368.61S245,403.54,245,403.56c1.49,6.67,2.68,12.55,3,15.64,0,0,0,0,0,.05a4.71,4.71,0,0,1,0,2.17.11.11,0,0,1,0,.06c-1.68,1.79-54.65,15.3-56.65,15.14s-1.74-5.87-.1-8,19.61-16.41,19.61-16.41l-7.3-35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.37,426.54l-2.72.74a2.57,2.57,0,0,0-.46-.82,2.75,2.75,0,0,0-3.87-.41,2.8,2.8,0,0,0-1,2.68l-2.47.68a2.76,2.76,0,0,0-5.31,1.45l-2.48.68a2.55,2.55,0,0,0-.47-.89,2.76,2.76,0,0,0-4.83,2.34l-2.47.68a2.85,2.85,0,0,0-.5-.92,2.75,2.75,0,0,0-4.82,2.37l-2.48.67a2.73,2.73,0,0,0-.49-.94,2.76,2.76,0,0,0-4.82,2.4l-2.47.67a2.61,2.61,0,0,0-.5-1,2.77,2.77,0,0,0-4.82,2.44l-2.47.67a2.61,2.61,0,0,0-.51-1,2.76,2.76,0,0,0-4.8,2.47l-2.33.63-1-5.51L248,421.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,410a11.61,11.61,0,0,0-7.92,4.95,11.24,11.24,0,0,0-1.86,8.16c0,.08.17.06.17,0a13.43,13.43,0,0,1,9.64-12.91A.09.09,0,1,0,244.84,410Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.61,403.33c-3.92.54-7.78,1.41-11.62,2.31s-7.6,1.81-11.39,2.75c-2.17.54-4.35,1.08-6.49,1.74a.11.11,0,0,0,.06.22c3.9-.6,7.76-1.5,11.61-2.32s7.64-1.67,11.44-2.59c2.18-.52,4.33-1.1,6.47-1.79A.17.17,0,0,0,242.61,403.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.52,400.41c-3.91.55-7.77,1.42-11.62,2.32s-7.6,1.81-11.39,2.75c-2.17.53-4.34,1.08-6.48,1.73a.12.12,0,0,0,.05.23c3.9-.6,7.76-1.5,11.62-2.33s7.63-1.66,11.43-2.58c2.18-.53,4.34-1.11,6.47-1.79A.17.17,0,0,0,241.52,400.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.37,337.32l-16.11,4.38c-.61.17-1.07,4.89-1.07,4.89s-41.92-23.26-59.09-23.68c-5.88-.15-19.4,9.52-20.15,18.82-1.22,15.06.37,36.16,3.22,48.52a29.93,29.93,0,0,0,5.06,10.31l35.82-6.67s.64-7.35-.08-11.41c-1.09-6.15-5.14-20.09-5.14-20.09,11.51,1.93,42.68,17.47,42.68,17.47s16.83,13.12,34.91-2.09Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.37,340.52a70.33,70.33,0,0,1-1.9,10.65c0,.13-.22.11-.19,0,.53-3.56,1-7.16,1.72-10.68C279.05,340.18,279.4,340.24,279.37,340.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.39,335.4c.08,0,.13.13.05.16a76.93,76.93,0,0,0-7.65,3c-1.16.51-7.52,3.74-6.54,5.89.16.36.55.45,1.08.34a8.32,8.32,0,0,0,2-1c1.32-.71,2.66-1.36,4-2a36.94,36.94,0,0,1,7.82-2.46c.09,0,.11.12,0,.15a71.72,71.72,0,0,0-10.61,4.23c-1.65.85-4,2.66-4.72.74s3.32-4.69,4.45-5.33A39.14,39.14,0,0,1,295.39,335.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,344.17a15.84,15.84,0,0,1-1.55,1.18,3.86,3.86,0,0,1-1.32.71c-.1,0-.13-.11-.08-.18a5.18,5.18,0,0,1,1.2-1.09c.47-.39.94-.78,1.42-1.15C281.06,343.39,281.37,343.9,281.07,344.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.76,394.52c3.86-.47,7.67-1.26,11.46-2.08s7.51-1.66,11.25-2.52c2.14-.5,4.29-1,6.41-1.61a.11.11,0,0,0,0-.22c-3.85.52-7.66,1.34-11.47,2.09s-7.53,1.51-11.28,2.35c-2.16.49-4.28,1-6.4,1.66A.17.17,0,0,0,209.76,394.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.61,337.32a8.5,8.5,0,0,0,.64,4.07c.23.65.52,1.27.79,1.91s.63,1.22,1,1.82a42.81,42.81,0,0,0,4.74,6.62,57,57,0,0,0,5.67,5.75,48,48,0,0,0,6.42,4.9c-1.55-2.25-3.27-4.28-5-6.32s-3.43-4-5.15-6-3.42-4-5-6.06c-.79-1-1.59-2.07-2.3-3.16A12.08,12.08,0,0,1,218.61,337.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.13,326c-2.23-4.59-9.28-5.75-15.75-2.6s-9.89,9.42-7.65,14,9.29,5.75,15.75,2.6S228.37,330.57,226.13,326Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.13,326c-2.23-4.59-9.28-5.75-15.75-2.6s-9.89,9.42-7.65,14,9.29,5.75,15.75,2.6S228.37,330.57,226.13,326Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.21,334.31c-12.87-18.35-20-33.79-19.62-40.64.31-6,3.4-23.63,9-33.19,1.69-2.88,19.54,4.1,19.1,7.64s-5.75,22-6.24,26.64c-.29,2.61,5,29.21,6.3,35.23C343,340,337.92,342.45,332.21,334.31Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.32,247.54c-1,1-1.49.5-1.25-1.95s3.25-12-.16-12.73-7.46,12.7-7.54,16.82a65.54,65.54,0,0,0,1.23,10.8C322.92,258,326.68,252.34,329.32,247.54Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.7,268.12c3.45-7.08,8.18-15.68,7.49-24.54a4.41,4.41,0,0,0-1.09-2.67c-.24-4-2.19-5-2.19-5-1.35-3.64-3.5-4.47-3.5-4.47s-.33-4.66-3.18-4.93c-3.2-.31-2.11,6.3-3.73,10.31-3.72,9.17-11.56,21.17-12.9,23.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.36,249.12a64.7,64.7,0,0,0,2.8-8.22,63.61,63.61,0,0,0,1.17-9.43.08.08,0,1,1,.15,0,33.56,33.56,0,0,1-4,17.69C337.42,249.29,337.31,249.25,337.36,249.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.57,252.16c.87-2.7,2.36-7.46,2.25-16.3,0,0,.05,0,.05,0a30.2,30.2,0,0,1-2.17,16.35C342.63,252.37,342.51,252.34,342.57,252.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.4,253.75a47.29,47.29,0,0,0,1.68-12.82s.05,0,.06,0c.42,5.77-.08,7.92-1.58,12.89C345.5,254,345.35,253.93,345.4,253.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.7,268.12l-19.1-7.64a12.12,12.12,0,0,0-5,4.65c-2,3.32-5.69,26.44-4.24,33s13.9,30.48,20.68,38.51,9.62,2.2,8.49-4.59-6.16-35.15-6.14-36.85,5.23-16.95,6-20.1S340.7,268.12,340.7,268.12Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,336.63c-5.14-6.08-13.55-21.34-17.95-31.21l23.17,7.67c1.33,7.74,2.74,15.74,3.27,19C342.68,338.83,339.84,344.66,333.06,336.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.82,272.91c-2.63-1.21-5.33-2.28-8-3.33s-5.35-2.08-8-3.1c-1.54-.58-3.08-1.17-4.63-1.7-.1,0-.13.06,0,.11,2.65,1.18,5.36,2.24,8.05,3.32s5.33,2.14,8,3.17c1.53.59,3.07,1.16,4.63,1.67C339.92,273.1,340,273,339.82,272.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,335.06l23.5,42a9.54,9.54,0,0,0,7.13-1.29c8.73-5.17,23.13-17.64,28.53-28.89,3.88-8.1.78-14.56-5.2-17.08-1.51-.63-21.22-6.9-28.29-6.25a57.2,57.2,0,0,0-21.88,7.37A11.4,11.4,0,0,0,292,335.06Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5,335.35c-.09-.61,3.34-2.41,3.83-2.23s24.66,43.78,24.72,44.1-4.15,2.36-4.45,2S289.61,336.18,289.5,335.35Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5,335.35c-.09-.61,3.34-2.41,3.83-2.23s24.66,43.78,24.72,44.1-4.15,2.36-4.45,2S289.61,336.18,289.5,335.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.3 344.16 313.18 323.13 331.76 322.92 335.89 343.95 317.3 344.16",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.3 344.16 313.18 323.13 331.76 322.92 335.89 343.95 317.3 344.16",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.3 344.16 316.78 341.49 335.37 341.28 335.89 343.95 317.3 344.16",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13,326.58a1.45,1.45,0,0,1-1.41-1.07.93.93,0,0,1,1-1.09,1.45,1.45,0,0,1,1.41,1.07A.93.93,0,0,1,328.13,326.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.2,326.62a1.44,1.44,0,0,1-1.41-1.06.92.92,0,0,1,1-1.09,1.44,1.44,0,0,1,1.41,1.06A.93.93,0,0,1,324.2,326.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.27,326.66a1.41,1.41,0,0,1-1.41-1.06.92.92,0,0,1,1-1.09,1.42,1.42,0,0,1,1.41,1.06A.91.91,0,0,1,320.27,326.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.58,
    cy: 328.85,
    rx: 1.03,
    ry: 1.26,
    transform: "translate(-111.61 478.31) rotate(-63.78)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.86,330a1.42,1.42,0,0,1-1.41-1.06.91.91,0,0,1,1-1.09,1.41,1.41,0,0,1,1.41,1.06A.92.92,0,0,1,324.86,330Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.92,330a1.44,1.44,0,0,1-1.41-1.06.93.93,0,0,1,1-1.09,1.43,1.43,0,0,1,1.41,1.06A.92.92,0,0,1,320.92,330Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.45,333.27a1.41,1.41,0,0,1-1.41-1.06.92.92,0,0,1,1-1.09,1.42,1.42,0,0,1,1.41,1.06A.91.91,0,0,1,329.45,333.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51,333.32a1.44,1.44,0,0,1-1.41-1.06.92.92,0,0,1,1-1.09,1.43,1.43,0,0,1,1.41,1.06A.92.92,0,0,1,325.51,333.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.58,333.36a1.44,1.44,0,0,1-1.41-1.06.92.92,0,0,1,1-1.09,1.44,1.44,0,0,1,1.41,1.06A.92.92,0,0,1,321.58,333.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.05,334c1.19,2.92,8.06,4.46,12.35,3.94.29,0,2.29-2,4.82-4.17,1.55-1.34,3.3-2.8,5-4C360.56,329.53,350,321,350,321a33.42,33.42,0,0,1-5.76,5.68,5.75,5.75,0,0,1-.75.43l-.13.06C341.91,327.91,336.9,331.21,338.05,334Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.7,329.16c-3.22,1.56-11.41,4.73-15.6-.85a8.06,8.06,0,0,1-.72-1.12.56.56,0,0,1,.13-.07,5.65,5.65,0,0,0,.75-.42A33.52,33.52,0,0,0,350,321S357.63,327.15,359.7,329.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.32,324.25c-3.52,3.34-16.58,7.13-20.72,5.52-6-2.33-9.87-9.14-6.38-15,3.38-5.67,20.49-10.32,24.56-8.24C375.78,309.59,377.5,319.32,372.32,324.25Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,316.32s0,.08-.05.1c-.89.28-1.87.76-1.87,1.67,0,0-.05,0-.05,0C356.22,317.07,357.52,316.45,358.41,316.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62,316.78c.61,1.38-2.19,2.51-2.76,1.23S359.1,315.62,359.62,316.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.57,311.54s-.07-.05-.11,0c-.86.37-1.9.66-2.51,0,0,0-.06,0,0,0C354.43,312.43,355.81,312,356.57,311.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.16,310.4c-.45-1.44-3.3-.43-2.88.91S357.54,311.61,357.16,310.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,317.36c0-.42,0-.82,0-1.24a2,2,0,0,1,.25-1.26.64.64,0,0,1,.76-.16,1.61,1.61,0,0,1,.68,1.46,2.36,2.36,0,0,1-.52,1.6A.69.69,0,0,1,361.44,317.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,308.75c.22.36.49.66.74,1s.48.71.95.87a.64.64,0,0,0,.71-.32,1.59,1.59,0,0,0-.32-1.58,2.37,2.37,0,0,0-1.35-1A.69.69,0,0,0,358,308.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61,319.41a8,8,0,0,0-1.17-3.49c0-.11.13-.28.22-.33h0l1.86-.68c-.22-.19-1.26-1.2-.91-1.32a47.9,47.9,0,0,1,9.32-2.37.09.09,0,0,1,0,.17c-2.78,1-5.73,1.57-8.54,2.57a5.26,5.26,0,0,1,1,1.21c0,.11-2,.61-2.29.76a4.59,4.59,0,0,1,.87,3.35C351.9,319.74,351.61,320,351.61,319.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.57,318.39c0-.56,1.66-2.11,2.12-1.31a4.37,4.37,0,0,1-.3,4.18c-.86,1.07-1-1.75-1.34-2.08S349.59,318.8,349.57,318.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,319.17l-.16-.16a1.58,1.58,0,0,1,2.08,1.06,3,3,0,0,1-.56,1.19C350.53,322.32,350.37,319.51,350,319.17Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.38,322.89c-.28-.13-.64-.23-.79-.53a2.48,2.48,0,0,1-.15-1,0,0,0,0,0-.06,0,1.27,1.27,0,0,0,0,1.28,1,1,0,0,0,1,.38A.05.05,0,0,0,350.38,322.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.24,328.49c-1.54-3,1.44-6.19,4.71-6.74,0,0-4.62-7.73,1.79-10.95a8.52,8.52,0,0,1-5.74-4.42l-2.33.49c-.11-.95,1.89-2.87,4.65-1.62a8.54,8.54,0,0,1,6.35.3,4.88,4.88,0,0,1,2.75,4.53,7.4,7.4,0,0,1,3.35,4.42,6.3,6.3,0,0,1-1.31,5.61s1,4.39-1.61,6.33a6.5,6.5,0,0,1-5.16,1.27s-.69,1.51-3.38,2.05C364.59,330.11,362.71,329.38,362.24,328.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.41,310.73a7.9,7.9,0,0,0-1.62.67,7.35,7.35,0,0,0-1.43,1,4.5,4.5,0,0,0-1.54,2.91,7.35,7.35,0,0,0,.54,3.35c.25.53.46,1.07.73,1.58s.58,1,.86,1.54c-.35-.47-.69-.95-1-1.43s-.56-1.05-.85-1.57a7.27,7.27,0,0,1-.66-3.51,4.69,4.69,0,0,1,1.75-3.11A7.05,7.05,0,0,1,369.41,310.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.46,320.11a8.07,8.07,0,0,1,.65,3.3,5,5,0,0,1-1.14,3.21,5.37,5.37,0,0,1-1.38,1.05,5.06,5.06,0,0,1-1.61.61,4.59,4.59,0,0,1-3.29-.57,5.11,5.11,0,0,0,3.22.26,5.71,5.71,0,0,0,2.75-1.62,4.19,4.19,0,0,0,.82-1.36,6.14,6.14,0,0,0,.31-1.59A10.21,10.21,0,0,0,376.46,320.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.42,310.08a8.46,8.46,0,0,0-.57-2.61,5,5,0,0,0-1.51-2.09,5.21,5.21,0,0,0-2.38-1,9.19,9.19,0,0,0-2.67,0,6.69,6.69,0,0,1,2.71-.31,4.59,4.59,0,0,1,4.15,3.3A6.44,6.44,0,0,1,374.42,310.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.78,308.14a9.31,9.31,0,0,0,2.41,1.91,5.39,5.39,0,0,0,1.42.53,7.06,7.06,0,0,0,1.54.15,3.74,3.74,0,0,1-1.6.16,4.23,4.23,0,0,1-1.55-.47,5.18,5.18,0,0,1-1.29-1A5,5,0,0,1,363.78,308.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8,326.21s5.21.88,5.07,3.11-6.77,2.88-8.53,1.17a2.34,2.34,0,0,1-.21-3.38Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,329.46s0,.06-.05,0a5.94,5.94,0,0,0-4.67-1.18,1.29,1.29,0,0,1,1.15,1.6c0,.05-.08,0-.09,0a1.46,1.46,0,0,0-1.14-1.22,6.69,6.69,0,0,0-1.48-.14c-.17,0-.21-.27,0-.29h0C359.54,327.34,362.83,327.55,364,329.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356,321.35a.19.19,0,0,0-.08.25.19.19,0,1,0,.08-.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.34,317.84a.19.19,0,0,0-.08.25.18.18,0,0,0,.25.07.19.19,0,0,0,.08-.25A.18.18,0,0,0,354.34,317.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.77,319.68a.18.18,0,0,0-.07.25.19.19,0,0,0,.25.08.19.19,0,0,0-.18-.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.3,320.54a.19.19,0,1,0,.25.08A.19.19,0,0,0,357.3,320.54Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M355.52,319.41a.19.19,0,1,0,.25.08A.19.19,0,0,0,355.52,319.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M353.44,309.72a.19.19,0,1,0,.17.33.19.19,0,0,0,.08-.25A.19.19,0,0,0,353.44,309.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M353.18,311.49a.19.19,0,1,0,.25.08A.19.19,0,0,0,353.18,311.49Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M351.93,311.73a.19.19,0,0,0-.08.25.18.18,0,0,0,.25.08.19.19,0,0,0-.17-.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M352.09,310.22a.19.19,0,1,0,.25.08A.19.19,0,0,0,352.09,310.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M350.31,339.05s4.92-3.23,4.76-3.9-6.26-1.26-8.35-3.27-2.86-5-3.1-5.34-4.42,2.9-5.25,3.81a3.2,3.2,0,0,0-.5,4.27C340,337.8,347.68,339.82,350.31,339.05Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.49,335.34a12.88,12.88,0,0,0-3.61,3,12.71,12.71,0,0,0,3.61-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.44,327.34a12.61,12.61,0,0,0-3.79,2.72,12.61,12.61,0,0,0,3.79-2.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.36,329.12a21.87,21.87,0,0,0-5,3.62,22.72,22.72,0,0,0,5-3.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,331a22.43,22.43,0,0,0-5,3.62,22.43,22.43,0,0,0,5-3.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,332.72a22.4,22.4,0,0,0-5,3.62,22.72,22.72,0,0,0,5-3.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.45,333.93a20,20,0,0,0-4.78,3.44,20.53,20.53,0,0,0,4.78-3.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.91,334.8a16.09,16.09,0,0,0-4.12,3.22,15.92,15.92,0,0,0,4.12-3.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7,343.73a6.6,6.6,0,0,1-3.52.34c-3.82-.65-8.29-4.66-9.66-9.86-.87-3.33-.36-5.79.88-7.43A25,25,0,0,0,349.7,343.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.26,330c3.89-11.95-.95-28.74-19.4-30.66C352.11,298,340.7,306.24,337.44,316c-4.61,13.8,6.17,28.54,18.06,30.37C364.53,347.75,380.17,342.59,384.26,330Zm-30,8.27c-8.65-1.79-16.85-13.83-13.89-24.71A17.51,17.51,0,0,1,359.77,301c13.39,2,18.25,15.25,15.77,24.67C372.93,335.61,360.86,339.58,354.3,338.23Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3,338.23c-8.65-1.79-16.85-13.83-13.89-24.71A17.51,17.51,0,0,1,359.77,301c13.39,2,18.25,15.25,15.77,24.67C372.93,335.61,360.86,339.58,354.3,338.23Z",
    style: {
      fill: "#455a64",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3,338.23c-8.65-1.79-16.85-13.83-13.89-24.71A17.51,17.51,0,0,1,359.77,301c13.39,2,18.25,15.25,15.77,24.67C372.93,335.61,360.86,339.58,354.3,338.23Z",
    style: {
      fill: "#455a64",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.37,312.13a130,130,0,0,0-27.2-8.13,17.19,17.19,0,0,1,6.68-2.89,132.9,132.9,0,0,1,16.39,5A19.27,19.27,0,0,1,374.37,312.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.53,337.93a17.16,17.16,0,0,1-7.23.3,15.69,15.69,0,0,1-7.28-4A105.12,105.12,0,0,1,361.53,337.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.6,315.85a126.2,126.2,0,0,0-31.35-9.26q.28-.33.6-.63A127.37,127.37,0,0,1,375.39,315C375.47,315.28,375.54,315.57,375.6,315.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.25,334.47a110.58,110.58,0,0,0-27.39-7.34c-.12-.24-.23-.49-.34-.75A111.92,111.92,0,0,1,369.86,334Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,336.89c-.31.12-.62.24-.94.34a108.72,108.72,0,0,0-18.62-4.8c-.22-.25-.44-.51-.65-.78A107.07,107.07,0,0,1,364.84,336.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.72,329.82a116,116,0,0,0-33.8-9.44,16.43,16.43,0,0,1-.11-2.53,118,118,0,0,1,35,9.89A13.73,13.73,0,0,1,373.72,329.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.17,348.9c3.1,0,8.53-2.1,10-5.89,1.42-3.58-.12-8.17-6.47-7.95-4.38.15-8.37,3-9.56,5.92C358.48,345.12,362.09,348.88,366.17,348.9Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.17,348.9c3.1,0,8.53-2.1,10-5.89,1.42-3.58-.12-8.17-6.47-7.95-4.38.15-8.37,3-9.56,5.92C358.48,345.12,362.09,348.88,366.17,348.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.48,349.35c2.38,0,6.54-1.62,7.7-4.53,1.09-2.75-.1-6.28-5-6.11-3.37.12-6.43,2.3-7.35,4.55C361.57,346.44,364.34,349.33,367.48,349.35Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,354.36c-17.85-.3-42.43-10.8-48.22-14.65-8.81-5.87-5.36-39.43-5.1-46.2.12-2.89,25.92,2.07,25.86,5.16-.05,2.7-3.59,28.49-2.6,29.08.81.48,18.69,10,30.59,17C351.73,350.71,345.67,354.44,341,354.36Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.88,304.71s.49-4.41.51-4.7a15.92,15.92,0,0,1,1.28-4.38c2.15-5.5,3.88-20.28-8.31-31.56-4.68-4.33-9.75-2.93-5.69,2.42,2.86,3.77,5.16,6.13,5.75,7.63,0,0-7-1.79-10.22.92a77.36,77.36,0,0,0-7.85,7.69,15.13,15.13,0,0,0,1.3,1.6,8.83,8.83,0,0,0-2,9.18l-.45,7.51Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.89,290.05c-1.05-2.91-3.37-9.06-7-13.42-4.05-4.85-13.16-13.1-16.71-10.07-2.6,2.22.6,5.67.6,5.67s-4.48-2.61-6.39-.09c-1.75,2.29.89,4.82.89,4.82s-3-1.12-4.24,1.41c-1.51,3.05,5,4.89,6.15,9.3C289.43,288.66,315.89,290.05,315.89,290.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.46,281.76a25.09,25.09,0,0,0-11.57-9.55c-.12,0-.22,0-.12.09a62,62,0,0,1,11.65,9.5S304.48,281.79,304.46,281.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.45,285.71c-1.47-2.1-6.6-7.06-12.12-8.85-.12,0-.22,0-.11.1a66.44,66.44,0,0,1,12.19,8.79S299.47,285.74,299.45,285.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.88,304.71,287.18,301s-2.6,1.9-2.86,8.71,2.29,26.16,7,30,27.74,12.95,44,14.88,13.46-6.84,6-10.54-29.49-16.48-29.77-16.92,2.29-12.11,2.49-16.23S312.88,304.71,312.88,304.71Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.21,329.4c1.3.93,2.63,1.79,4,2.64s2.7,1.66,4.07,2.47,2.76,1.58,4.16,2.31l2.12,1.11c.72.34,1.42.71,2.16,1-.65-.47-1.31-.9-2-1.35l-2-1.29c-1.33-.85-2.7-1.66-4.07-2.47s-2.76-1.57-4.17-2.31S316.66,330.06,315.21,329.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,336.56a9,9,0,0,0,1.61.54,14.92,14.92,0,0,0,1.67.3,3.29,3.29,0,0,0-.76-.41,6.21,6.21,0,0,0-2.52-.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.85,341.33c1.28.78,2.62,1.47,3.95,2.17s2.7,1.32,4.07,1.94c2.73,1.25,5.54,2.34,8.36,3.37s5.71,1.91,8.63,2.65a83.33,83.33,0,0,0,8.83,1.83c-1.45-.41-2.92-.72-4.35-1.15s-2.89-.79-4.32-1.24l-4.29-1.33c-1.42-.49-2.84-.95-4.24-1.47-2.83-1-5.62-2.07-8.39-3.19S296.57,342.59,293.85,341.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.5,352.13a8.43,8.43,0,0,0,3,1.86,7.29,7.29,0,0,0-1.41-1.09A8.23,8.23,0,0,0,322.5,352.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,308.72c-2.83-.59-5.71-1-8.58-1.46s-5.68-.82-8.52-1.22c-1.63-.23-3.26-.46-4.89-.63-.11,0-.12.09,0,.11,2.83.56,5.71,1,8.58,1.45s5.67.9,8.51,1.31c1.63.23,3.26.44,4.89.59C310.85,308.89,310.86,308.75,310.71,308.72Z",
    style: {
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.d3b2399a04e900799caafb673c52982a.svg";
export { ForwardRef as ReactComponent };